(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["TK-steps-journey"] && !Shopify.designMode) return;
  try {
    
(function(){
  function ready(fn){ if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }

  ready(function(){
    var sections = document.querySelectorAll('.tk-steps');
    if(!sections.length) return;

    function ensureSwiper(cb){
      if (window.Swiper) return cb();
      if(!document.querySelector('link[data-swiper]')){
        var l=document.createElement('link'); l.rel='stylesheet'; l.href='https://unpkg.com/swiper@9/swiper-bundle.min.css'; l.setAttribute('data-swiper','1'); document.head.appendChild(l);
      }
      var s=document.createElement('script'); s.src='https://unpkg.com/swiper@9/swiper-bundle.min.js'; s.onload=cb; document.head.appendChild(s);
    }

    function imagesReady(root, cb){
      var imgs = root.querySelectorAll('.tk-step__img');
      var remaining = 0; function done(){ remaining--; if(remaining<=0) cb(); }
      imgs.forEach(function(img){ if(!img.complete){ remaining++; img.addEventListener('load', done, {once:true}); img.addEventListener('error', done, {once:true}); } });
      if(remaining===0) cb();
    }

    function equalizeCards(root){
      var cards = root.querySelectorAll('.tk-steps__slider .tk-step__card');
      if(!cards.length) return;
      cards.forEach(function(c){ c.style.minHeight=''; });
      var maxH = 0; cards.forEach(function(c){ var h=c.offsetHeight; if(h>maxH) maxH=h; });
      if(maxH>0) root.style.setProperty('--tk-card-fixed-h', maxH+'px');
    }

    function initSwiper(root){
      var el = root.querySelector('.tk-steps__slider'); if(!el) return;
      var pagEl = root.querySelector('.tk-steps__pagination');
      var gap = parseFloat(getComputedStyle(root).getPropertyValue('--tk-gap')) || 16;

      function setup(){
        var isMobile = window.matchMedia('(max-width: 1224px)').matches;
        if (isMobile) {
          if (el.swiper) {
            el.swiper.params.spaceBetween = gap;
            el.swiper.update();
          } else {
            new Swiper(el, {
              slidesPerView: 1.1,
              spaceBetween: gap,
              centeredSlides: false,
              loop: false,
              autoHeight: false,
              grabCursor: true,
              watchOverflow: true,
              keyboard: { enabled: true },
              pagination: pagEl ? { el: pagEl, clickable: true, dynamicBullets: false } : undefined
            });
          }
          // Equalize heights after init/update and after images load
          requestAnimationFrame(function(){ equalizeCards(root); });
          imagesReady(root, function(){ equalizeCards(root); });
        } else if (el.swiper) {
          el.swiper.destroy(true, true);
          root.style.removeProperty('--tk-card-fixed-h');
        }
      }

      setup();
      var mq = window.matchMedia('(max-width: 1224px)');
      if (mq.addEventListener) mq.addEventListener('change', setup); else mq.addListener(setup);
      if (window.ResizeObserver){ var ro = new ResizeObserver(function(){ equalizeCards(root); }); ro.observe(root); }
      window.addEventListener('orientationchange', function(){ setTimeout(function(){ equalizeCards(root); }, 300); });
    }

    ensureSwiper(function(){ sections.forEach(initSwiper); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Open the group that contains the current page's active link
  var groups = document.querySelectorAll('.blog-nav .blog-group');
  groups.forEach(function (group) {
    if (group.querySelector('.sidebar-link.active')) {
      group.setAttribute('open', '');
    }
  });

  // Handle empty links - prevent navigation
  var emptyLinks = document.querySelectorAll('.sidebar-link[href=""], .sidebar-link[href="#"]');
  emptyLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      return false;
    });
  });

  // Smooth scroll to active article if it exists
  var activeLink = document.querySelector('.sidebar-link.active');
  if (activeLink) {
    setTimeout(function() {
      activeLink.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center',
        inline: 'nearest'
      });
    }, 100);
  }

  // Add analytics tracking for blog navigation clicks
  var blogLinks = document.querySelectorAll('.sidebar-link[href]:not([href=""]):not([href="#"])');
  blogLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      // Track blog navigation clicks if analytics is available
      if (typeof gtag !== 'undefined') {
        gtag('event', 'blog_navigation_click', {
          'article_title': this.textContent.trim(),
          'article_url': this.href
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
